export interface OnlyMySelectionFilterType {
  showOnlyMySelection: boolean
}

export const initialOnlyMySelectionFilter: OnlyMySelectionFilterType = {
  showOnlyMySelection: false
};